import { render, staticRenderFns } from "./totpQrCode.vue?vue&type=template&id=b4d4f064&scoped=true&"
import script from "./totpQrCode.vue?vue&type=script&lang=js&"
export * from "./totpQrCode.vue?vue&type=script&lang=js&"
import style0 from "./totpQrCode.vue?vue&type=style&index=0&id=b4d4f064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d4f064",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
